<template>
  <div class="AddCourseResource">
    <a-spin class="AddCourseResource-left" :spinning="tree.treeLoading">
      <a-tabs @change="tabsChange" v-model="tabActive" v-if="showTabs">
        <a-tab-pane v-for="item in tabs" :key="item.type" :tab="item.name" />
      </a-tabs>
      <a-tree
        @select="treeSelect"
        :tree-data="tree.treeData"
        style="padding-right: 5px"
        :key="tree.key"
        :selectedKeys.sync="tree.selectValue"
        :replaceFields="{ key: 'id' }"
        show-icon
        default-expand-all
        block-node
      >
        <div slot="treeItem" slot-scope="title" class="tree-item">
          <img v-if="!(title.children && title.children.length)" class="tree-icon" src="@/assets/img/course/course-file.png" alt="" />
          <img v-else class="tree-icon" src="@/assets/img/course/course-folder.png" alt="" />
          <span :title="title.name">{{ title.name }}</span>
        </div>
      </a-tree>
    </a-spin>
    <div class="AddCourseResource-right">
      <a-form-model layout="inline" :model="searchForm" style="margin-bottom: 15px">
        <a-form-model-item label="资源包系列">
          <a-input :maxLength="30" allowClear v-model="searchForm.name" placeholder="请输入系列名称" />
        </a-form-model-item>
        <a-form-model-item label="资源包名称">
          <a-input :maxLength="30" allowClear class="serach-item" v-model="searchForm.courseName" placeholder="请输入资源名称" />
        </a-form-model-item>
        <a-form-model-item label="系列说明">
          <a-input :maxLength="30" allowClear v-model="searchForm.remark" placeholder="请输入关键词" />
        </a-form-model-item>
        <a-form-model-item>
          <a-button @click="getPageList(1)" type="primary" html-type="button"> 查询 </a-button>
          <a-button @click="searchReset" style="margin-left: 10px"> 重置 </a-button>
        </a-form-model-item>
      </a-form-model>
      <a-table
        :columns="columns"
        :key="tableRelevant.key"
        row-key="id"
        :pagination="tableRelevant.tablePagination"
        :loading="tableRelevant.tableLoading"
        :locale="tableRelevant.locale"
        :row-selection="rowSelection"
        :scroll="{ y: 350 }"
        :dataSource="tableRelevant.tableDataSource"
        @expand="changExpand"
      >
        <a-table
          slot="expandedRowRender"
          class="inner-table"
          slot-scope="text"
          :key="text.key"
          :row-key="(record) => JSON.stringify(record)"
          :columns="innerColumns"
          :row-selection="innerRowSelection"
          :data-source="text.tableData"
          :loading="text.tableLoading"
          :pagination="false"
        >
          <div class="course-name" slot="name" :title="text.name" slot-scope="text">
            <img :src="text.icon | filterUrl" alt="" />
            <span>{{ text.name }}</span>
          </div>
          <div slot="size" slot-scope="text">
            <span>{{ text.size || '--' }}</span>
          </div>
          <div slot="enabled" slot-scope="text">
            <span>{{ text.enabled ? '开启' : '禁用' }}</span>
          </div>
        </a-table>
      </a-table>
    </div>
  </div>
</template>

<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'

const columns = [
  { title: '资源包系列', dataIndex: 'name', width: 250, ellipsis: true },
  { title: '系列说明', dataIndex: 'remark', ellipsis: true },
]
const innerColumns = [
  {
    title: '资源包名称',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '资源个数',
    dataIndex: 'count',
  },
  { title: '文件大小', scopedSlots: { customRender: 'size' } },
  { title: '更新时间', dataIndex: 'updateTime' },
  { title: '状态', scopedSlots: { customRender: 'enabled' } },
]

export default {
  name: 'AddCourseResource',
  props: {
    type: String,
  },
  data() {
    return {
      visible: false,
      confirmLoading: false,
      organizationId: sessionStorage.getItem('ORGANIZATION_ID'),
      tabs: [
        { type: 1, name: 'B端' },
        { type: 2, name: 'C端' },
        // { type: 3, name: '实验' },
      ],
      tabActive: 1,
      tree: {
        key: Date.now(),
        selectValue: undefined,
        treeLoading: false,
        treeData: [],
      },
      columns,
      innerColumns,
      searchForm: {
        name: undefined,
        courseName: undefined,
        remark: undefined,
        classificationId: undefined,
      },
      tableRelevant: tableRelevant.call(this),
      table: tableRelevant.call(this),
      seriesSelectedRowKeys: [],
      courseSelectedRowKeys: [],
      showTabs: true,
      allResourse: [],
    }
  },
  computed: {
    rowSelection() {
      return {
        hideDefaultSelections: true,
        selectedRowKeys: this.seriesSelectedRowKeys,
        onSelect: (record, selected) => {
          this.selectTableRow(selected, [record])
          if (selected) {
            if (record.tableData) {
              record.tableData.forEach((item) => {
                if (item.enabled && !this.courseSelectedRowKeys.includes(JSON.stringify(item))) {
                  this.courseSelectedRowKeys.push(JSON.stringify(item))
                }
              })
            } else {
              this.getCourseList(record, true)
            }
          } else {
            const selectItems = record.tableData.map((v) => JSON.stringify(v))
            this.courseSelectedRowKeys = this.courseSelectedRowKeys.filter((v) => !selectItems.includes(v))
            this.seriesSelectedRowKeys = this.seriesSelectedRowKeys.filter((v) => v != record.id)
          }
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          this.selectTableRow(selected, changeRows, true)
        },
        // onChange: (selectedRowKeys, selectedRows) => {
        //   this.seriesSelectedRowKeys = selectedRowKeys
        // },
      }
    },
    innerRowSelection() {
      return {
        selectedRowKeys: this.courseSelectedRowKeys,
        getCheckboxProps: (record) => ({
          props: {
            disabled: !record.enabled,
          },
        }),
        onSelect: (record, selected) => {
          if (selected) {
            this.courseSelectedRowKeys.push(JSON.stringify(record))
          } else {
            this.courseSelectedRowKeys = this.courseSelectedRowKeys.filter((v) => v != JSON.stringify(record))
          }
          const series = this.tableRelevant.tableDataSource.find((v) => record.seriesId == v.id)
          const isAll = series.tableData.filter(item=>item.enabled).every((item) => this._currentSelectRow.includes(JSON.stringify(item)))
          if (isAll) {
            this.seriesSelectedRowKeys.push(record.seriesId)
          } else {
            this.seriesSelectedRowKeys = this.seriesSelectedRowKeys.filter((v) => v != record.seriesId)
          }
        },
        onChange: (selectedRowKeys, _) => {
          this._currentSelectRow = selectedRowKeys
        },
      }
    },
  },
  mounted() {},
  methods: {
    getListAll() {
      this.$http.CourseService.getResourseListAllByOrg(this.organizationId).then((res) => {
        this.allResourse = res.data
        this.tabsChange()
      })
    },
    selectTableRowAll(selected, selectedRows, selectAll) {
      this.seriesSelectedRowKeys = []
      this.courseSelectedRowKeys = []
      if (selected) {
        const getItems = []
        for (let i = 0; i < selectedRows.length; i++) {
          const item = selectedRows[i]
          this.seriesSelectedRowKeys.push(item.id)
          const tableData = item.tableData
          if (tableData) {
            tableData.forEach((item) => {
              if (item.enabled) {
                this.courseSelectedRowKeys.push(JSON.stringify(item))
              }
            })
          } else {
            getItems.push(item)
          }
        }
        if (getItems.length) {
          this.getCourseListAll(getItems)
        }
      }
      return
    },
    selectTableRow(selected, selectedRows, selectAll) {
      if (selectAll !== undefined) {
        return this.selectTableRowAll(selected, selectedRows, selectAll)
      }
      if (selected) {
        for (let i = 0; i < selectedRows.length; i++) {
          this.seriesSelectedRowKeys.push(selectedRows[i].id)
        }
      } else {
        this.seriesSelectedRowKeys = this.seriesSelectedRowKeys.filter((v) => !selectedRows.map((item) => item.id).includes(v.id))
      }
    },
    tabsChange() {
      function initData(arr, index) {
        return arr.map((m) => {
          if (m.id === null) {
            m.id = 0
          }
          if (m.children && m.children.length) {
            m.children = initData(m.children, index + 1)
          }
          m.index = index
          m.scopedSlots = { title: 'treeItem' }
          return m
        })
      }
      this.tree.treeLoading = true
      this.$http.CourseResource.classificationsGet({ type: this.tabActive, resourceType: 1 }).then((res) => {
        this.tree.treeLoading = false
        const { status, data, message } = res
        this.tree.treeData = initData([data], 0)
        this.tree.key = Date.now()
      })
      this.tree.selectValue = undefined
      this.searchReset()
    },
    treeSelect(selectedKeys) {
      this.searchForm.classificationId = selectedKeys[0] || undefined
      this.getPageList(1)
    },
    getPageList(page) {
      const params = {
        type: this.tabActive,
        enabled: true,
        pageIndex: page || this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
        resourceType: 1,
        ...this.searchForm,
      }
      this.tableRelevant.tableLoading = true
      this.$http.CourseResource.seriesGet(params)
        .then((res) => {
          const { status, data, message } = res
          this.tableRelevant.key = +new Date()
          this.tableRelevant.tableDataSource = data.items
          this.tableRelevant.tablePagination.total = data.totalCount
          this.tableRelevant.tablePagination.current = data.pageIndex
          return data.items.map((m) => m.id)
        })
        .finally(() => {
          this.tableRelevant.tableLoading = false
        })
    },
    searchReset() {
      this.searchForm = {
        name: undefined,
        remark: undefined,
      }
      this.getPageList(1)
    },
    changExpand(expand, record) {
      if (expand) {
        this.getCourseList(record)
      }
    },
    async getCourseListAll(records, checked) {
      this.confirmLoading = true
      const promises = records.map((v) => {
        let params = {
          seriesId: v.id,
          pageSize: 99999,
          ExcludedResourcePackageIds: this.allResourse,
          pageIndex: 1,
        }
        return this.$http.CourseResource.ResourcePackagePagelist(params)
      })

      const setTableData = (seriesId, index) => {}

      const results = await Promise.all(promises).finally(() => {
        this.confirmLoading = false
      })
      this.courseSelectedRowKeys = results
        .map((res) => res.data.items)
        .flat(2)
        .map((v) => JSON.stringify(v))
    },
    getCourseList(record, checked) {
      let params = {
        seriesId: record.id,
        pageSize: 99999,
        ExcludedResourcePackageIds: this.allResourse,
        pageIndex: 1,
      }
      this.tableRelevant.tableLoading = true
      this.confirmLoading = true
      this.$http.CourseResource.ResourcePackagePagelist(params)
        .then((res) => {
          const { status, data, message } = res
          record.tableData = data.items
          if (checked) {
            data.items.forEach((item) => {
              if (item.enabled) {
                this.courseSelectedRowKeys.push(JSON.stringify(item))
              }
            })
          }
        })
        .finally(() => {
          this.confirmLoading = false
          this.tableRelevant.tableLoading = false
        })
    },
  },
}
</script>

<style scoped>
.AddCourseResource {
  display: flex;
}

.AddCourseResource-left {
  width: 300px;
  min-height: 360px;
  flex-shrink: 0;
  border-right: 1px solid #ebedf0;
  border-bottom: 1px solid #ebedf0;
  margin-bottom: 63px;
}

.AddCourseResource-right {
  flex-grow: 1;
  padding-left: 24px;
}

.tree-item {
  display: flex;
  align-items: center;
}

.tree-item > span {
  flex-shrink: 2;
  flex-grow: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
}

.tree-icon {
  width: 16px;
  height: 16px;
  object-fit: contain;
  margin-right: 5px;
}

.course-name {
  display: flex;
  align-items: center;
}

.course-name span {
  flex-grow: 2;
}

.course-name img {
  width: 25px;
  height: 25px;
  object-fit: contain;
  margin-right: 5px;
  flex-shrink: 0;
}

.inner-table >>> .ant-table-selection-column .ant-table-header-column {
  display: none;
}

/deep/ .ant-tabs-nav-wrap {
  display: flex;
  justify-content: center;
}
/* 隐藏表头的全选 checkbox */
/deep/ .ant-table-thead .ant-checkbox-wrapper,
/deep/ .ant-table-thead .ant-checkbox {
  display: none !important;
}
</style>
